import React, { Component, useEffect, useState } from "react";
import Moment from "react-moment";
import moment from "moment";
import config from "../config.json";
import ViewForm from "../components/PortalForms/ViewForm";
import AddEditNotes from "../components/OMCRegistry/AddEditNotes";
import ViewFormModal from "./ViewFormModal";
import { getFieldData } from "../services/appService";
import useDocDownload from "../app/hooks/useDocDownload";
import { useDispatch, useSelector } from "react-redux";
import { deleteDocument, getDocumentDeleteStatus, getDocuments, loadDocuments } from "../app/store/documents";
import { addFormLibrary, getAppFormLibrary, getLibraryFormAddedStatus, loadAppLibraryForms } from "../app/store/forms";
import { getSubcontractorById, getSubsCurrentWfTask, loadSubcontractorById, loadSubcontractorWfTask } from "../app/store/subcontractor";
import { getRecCurrentWfTask, getRecruiterById, loadRecruiterById, loadRecruiterWfTask } from "../app/store/recruiter";
import { getAlert, getConfirmAlert } from "../services/appAlerts";
import CandidateReqDoc from "../components/OMCRegistry/CandidateReqDoc";
import { getCandidateById, loadCandidateById } from "../app/store/candidate";
import { OverlayTrigger, Popover } from "react-bootstrap";
import TimerPopup from "./TimerPopup";
import { getAppTimerMessages, loadAppTimerMessages } from "../app/store/messages";

const InsuranseInformation = (props) => {
  const { workflowTask, item, app, setViewBprmFormShowHide, viewType, insuranceType, setSelectedApp, onBack, hideHeader } = props;

  const [formsLib, setFormsLib] = useState([]);
  const [appDocuments, setAppDocuments] = useState([]);
  const [selectedForm, setSelectedForm] = useState(null);
  const [achFormShowHide, setAchFormShowHide] = useState(false);
  const [noteShowHide, setNoteShowHide] = useState(false);
  const [partnerCurrentWfTask, setPartnerCurrentWfTask] = useState(null);
  const [achCheckCount, setAchCheckCount] = useState(0);
  const [partnerAppData, setPartnerAppData] = useState(null);
  const [docShowHide, setDocShowHide] = useState(false);
  const [uploadType, setUploadType] = useState("");
  const [timerShowHide, setTimerShowHide] = useState(false);
  const [tmrMessages, setTmrMessages] = useState([]);


  const appFormLibrarySelector = useSelector(getAppFormLibrary);
  const documentsSelector = useSelector(getDocuments);
  const subsCurrentWfTaskSelector = useSelector(getSubsCurrentWfTask);
  const recCurrentWfTaskSelector = useSelector(getRecCurrentWfTask);
  const libraryFormAddedStatusSelector = useSelector(getLibraryFormAddedStatus);
  const documentDeleteStatusSelector = useSelector(getDocumentDeleteStatus);
  const recruiterByIdSelector = useSelector(getRecruiterById);
  const subcontractorByIdSelector = useSelector(getSubcontractorById);
  const candidateByIdSelector = useSelector(getCandidateById);
  const appTimerMessagesSelector = useSelector(getAppTimerMessages);

  const [handleDownloadFile] = useDocDownload()
  const dispatch = useDispatch();

  useEffect(() => {
    if (workflowTask?.ciid && viewType !== "candidateList") {
      dispatch(loadAppLibraryForms(workflowTask.ciid));
      dispatch(loadDocuments(workflowTask.ciid));
      dispatch(loadAppTimerMessages(workflowTask.ciid));
      setAchCheckCount(1);
    }
    // else {
    //   setPartnerCurrentWfTask(null)
    //   if (item?.subcontractor?.parentid > 0 && insuranceType === "Subcontractor")
    //     dispatch(loadSubcontractorWfTask(item?.subcontractor?.parentid))

    //   if (item?.recruiter?.parentid > 0 && insuranceType === "Recruiter")
    //     dispatch(loadRecruiterWfTask(item?.recruiter?.parentid))
    // }
  }, [workflowTask, insuranceType]);


  useEffect(() => {
    setTmrMessages(appTimerMessagesSelector);
  }, [appTimerMessagesSelector])


  useEffect(() => {
    if (subsCurrentWfTaskSelector) {
      dispatch(loadAppLibraryForms(subsCurrentWfTaskSelector.ciid));
      dispatch(loadDocuments(subsCurrentWfTaskSelector.ciid));
      setPartnerCurrentWfTask(subsCurrentWfTaskSelector);
      setPartnerAppData(subsCurrentWfTaskSelector.appData)
      setAchCheckCount(1);
    }
  }, [subsCurrentWfTaskSelector])

  useEffect(() => {
    if (recCurrentWfTaskSelector) {
      dispatch(loadAppLibraryForms(recCurrentWfTaskSelector.ciid));
      dispatch(loadDocuments(recCurrentWfTaskSelector.ciid));
      setPartnerCurrentWfTask(recCurrentWfTaskSelector);
      setPartnerAppData(recCurrentWfTaskSelector.appData)
      setAchCheckCount(1);
    }
  }, [recCurrentWfTaskSelector])

  useEffect(() => {
    if (appFormLibrarySelector.length > 0) {
      const achForms = appFormLibrarySelector.filter(x => x.formType === "Insurance Information");
      if (achForms.length > 0) {
        setFormsLib(achForms);
        setAchCheckCount(0)
      }
      else {
        setFormsLib([]);
        if (achCheckCount === 1) setAchCheckCount(2);
      }
    }
    else {
      setFormsLib([]);
      if (achCheckCount === 1) setAchCheckCount(2);
    }
  }, [appFormLibrarySelector]);

  useEffect(() => {
    setAppDocuments(documentsSelector);
  }, [documentsSelector]);

  const handleFormShowHide = (f) => {
    setSelectedForm(f);
    setAchFormShowHide(!achFormShowHide);
    setViewBprmFormShowHide(!achFormShowHide);
  };

  const handleNoteShowHide = (type, obj) => {
    if (type === "save") {
      setSelectedForm(null)
      setNoteShowHide(false);
    } else {
      setSelectedForm(obj);
      setNoteShowHide(!noteShowHide);
    }
  };

  const handleCOIDoc = (item) => {
    const docs = appDocuments.filter((x) => x.uploadType === `insurance_${item.id}` && x.deleteFlag !== true);
    if (docs.length === 0) {
      return <button
        className="btn btn-link btn-sm p-0"
        onClick={() =>
          handleUploadDocModalShowHide(`insurance_${item.id}`)
        }
      >
        Upload
      </button>
    }

    return <>
      {docs.map(d =>
        <div className="text-nowrap">
          <button
            className="btn btn-link btn-sm p-0"
            title="Download Document"
            onClick={() => handleDownloadFile(d)}
          >
            {d.docName}
          </button>
          <button
            className="btn btn-sm btn-outline-default p-1 pl-2 pr-2"
            onClick={() => handleDeleteInsuranceDoc(d.docId)}
          >
            <i
              className="fa fa-trash"
              aria-hidden="true"
            ></i>
          </button>
        </div>
      )}
      {getPopover(docs[0].remarks)}
    </>

  }

  const getPopover = (notes) => {
    const popover = (
      <Popover id="popover-basic">
        <Popover.Title as="h4">Notes</Popover.Title>
        <Popover.Content>{notes}</Popover.Content>
      </Popover>
    );
    return (
      <React.Fragment>
        <OverlayTrigger trigger="click" placement="top" overlay={popover}>
          <span
            className="btn-sm btn-link text-primary p-0"
            style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "5px" }}
          >
            {/* <i className="fa fa-info-circle"></i> */}
            View Notes
          </span>
        </OverlayTrigger>
      </React.Fragment>
    );
  };

  const handleDeleteInsuranceDoc = async (id) => {
    const result = await getConfirmAlert("Warning", "Are you sure you want to delete this Document?", "warning");
    if (result.isConfirmed) {
      dispatch(deleteDocument(id));
    }
  }

  useEffect(() => {
    if (documentDeleteStatusSelector) {
      getAlert("", "Deleted Successfully", "success");
      if (workflowTask?.ciid && viewType !== "candidateList") {
        dispatch(loadDocuments(workflowTask.ciid));
        dispatch(loadAppLibraryForms(workflowTask.ciid));
      }
      // else if (partnerCurrentWfTask?.ciid > 0) {
      //   dispatch(loadDocuments(partnerCurrentWfTask.ciid));
      //   dispatch(loadAppLibraryForms(partnerCurrentWfTask.ciid));
      // }
    }
  }, [documentDeleteStatusSelector])

  const handleUploadDocModalShowHide = (type) => {
    if (type === "save") {
      setDocShowHide(false);
      setUploadType("");
      refereshFormData();
    }
    else {
      setDocShowHide(!docShowHide);
      setUploadType(type);
    }
  }

  const getModifiedFiledData = (ddType, name) => {
    if (workflowTask?.ciid && viewType !== "candidateList") {
      const dt = getFieldData(app?.applicationData, ddType, name);
      if (!dt) return "";
      return <Moment format="MMM Do YYYY">{dt}</Moment>
    } else {
      const dt = getFieldData(partnerAppData, ddType, name);
      if (!dt) return "";
      return <Moment format="MMM Do YYYY">{dt}</Moment>
    }

  }

  const getPolicyDate = (ddType, name) => {
    if (workflowTask?.ciid && viewType !== "candidateList") {
      const dt = getFieldData(app?.applicationData, ddType, name);
      if (!dt) return "";
      return dt
    } else {
      const dt = getFieldData(partnerAppData, ddType, name);
      if (!dt) return "";
      return dt
    }

  }

  const formatEditDate = (dateValue) => {
    if (!dateValue) return "Not Available";

    const parsedDate = moment(dateValue);
    if (!parsedDate.isValid() || parsedDate.year() <= 1900) {
      return "Not Available";
    }

    return parsedDate.format("MMM Do YYYY, h:mm a");
  };

  const addReqFormLibrary = () => {
    if (partnerCurrentWfTask?.ciid > 0 || workflowTask?.ciid > 0) {
      const insObj = {
        formId: 22,
        formName: "Insurance Details",
        remarks:
          "Upload your company's insurance certificate(s) as per the contract requirements",
        formType: "Insurance Information",
      };
      const frmData = new FormData();
      if (viewType === "candidateList")
        frmData.append("workflowTask", JSON.stringify(partnerCurrentWfTask));
      else
        frmData.append("workflowTask", JSON.stringify(workflowTask));
      frmData.append("formId", insObj.formId);
      frmData.append("formName", insObj.formName);
      frmData.append("remarks", insObj.remarks);
      frmData.append("id", "");
      frmData.append("formType", insObj.formType);
      frmData.append("status", "1");
      dispatch(addFormLibrary(frmData));
    }

  };

  useEffect(() => {
    if (libraryFormAddedStatusSelector) {
      getAlert("", "Added Successfully", "success");
      // if (partnerCurrentWfTask?.ciid > 0 || workflowTask?.ciid > 0) {
      //   if (viewType === "candidateList")
      //     dispatch(loadAppLibraryForms(partnerCurrentWfTask.ciid));
      //   else
      //     dispatch(loadAppLibraryForms(workflowTask.ciid));
      // }
      if (workflowTask?.ciid > 0) {
        dispatch(loadAppLibraryForms(workflowTask.ciid));
      }
    }
  }, [libraryFormAddedStatusSelector])

  const refereshFormData = () => {
    // if (partnerCurrentWfTask?.ciid > 0) {
    //   setPartnerCurrentWfTask(null);
    //   if (item?.subcontractor?.parentid > 0 && insuranceType === "Subcontractor")
    //     dispatch(loadSubcontractorWfTask(item?.subcontractor?.parentid))

    //   if (item?.recruiter?.parentid > 0 && insuranceType === "Recruiter")
    //     dispatch(loadRecruiterWfTask(item?.recruiter?.parentid))
    // }
    if (workflowTask?.ciid > 0) {
      //dispatch(loadAppLibraryForms(workflowTask.ciid));
      //dispatch(loadDocuments(workflowTask.ciid));
      var frmBody = new FormData();
      frmBody.append("id", insuranceType === "Candidate" ? item.performerid : item.fuid);
      frmBody.append("name", "");
      frmBody.append("email", "");
      frmBody.append("type", "");
      if (insuranceType === "Recruiter")
        dispatch(loadRecruiterById(frmBody));
      else if (insuranceType === "Subcontractor")
        dispatch(loadSubcontractorById(frmBody));
      else if (insuranceType === "Candidate") {
        frmBody.append("entity", "");
        frmBody.append("filterType", "single");
        dispatch(loadCandidateById(frmBody))
      }
    }
  }

  const handleDocumentLoad = () => {
    if (workflowTask?.ciid && viewType !== "candidateList") {
      setTimeout(() => {
        dispatch(loadAppLibraryForms(workflowTask.ciid));
      }, 3000);

      setTimeout(() => {
        dispatch(loadDocuments(workflowTask.ciid));
      }, 2000);

      setTimeout(() => {
        refereshFormData();
      }, 1000);
    }
    // else if (partnerCurrentWfTask?.ciid > 0) {
    //   dispatch(loadDocuments(partnerCurrentWfTask.ciid));
    //   dispatch(loadAppLibraryForms(partnerCurrentWfTask.ciid));
    // }
  }

  useEffect(() => {
    console.log(recruiterByIdSelector)
    if (recruiterByIdSelector.length > 0) {
      var part = recruiterByIdSelector[0];
      if (part.applications?.length > 0) {
        var partApp = part.applications[0];
        if (setSelectedApp)
          setSelectedApp(partApp)
      }
    }
  }, [recruiterByIdSelector])

  useEffect(() => {
    console.log(subcontractorByIdSelector)
    if (subcontractorByIdSelector.length > 0) {
      var part = subcontractorByIdSelector[0];
      if (part.applications?.length > 0) {
        var partApp = part.applications[0];
        if (setSelectedApp)
          setSelectedApp(partApp)
      }
    }
  }, [subcontractorByIdSelector])

  useEffect(() => {
    console.log(subcontractorByIdSelector)
    if (candidateByIdSelector.length > 0) {
      var part = candidateByIdSelector[0];
      if (part.applications?.length > 0) {
        var partApp = part.applications[0];
        if (setSelectedApp)
          setSelectedApp(partApp)
      }
    }
  }, [candidateByIdSelector])

  const handleTimerModalShowHide = () => {
    setTimerShowHide(!timerShowHide);
  };

  let candidateObj = "";
  if (item) {
    candidateObj = {
      performerid: item?.id,
      applicantId: item?.id,
    };

    if (item?.subcontractor?.parentid > 0 && insuranceType === "Subcontractor")
      candidateObj.applicantId = item?.subcontractor?.parentid;

    if (item?.recruiter?.parentid > 0 && insuranceType === "Recruiter")
      candidateObj.applicantId = item?.recruiter?.parentid;
  }

  return (
    <div className="ins-dashboard-container">
      <style>{`
        .ins-dashboard-container {
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
          color: hsl(210, 24%, 16%);
          margin-bottom: 2rem;
          background: #ffffff;
          border: 1px solid rgba(226, 232, 240, 0.9);
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 18px 45px rgba(15, 23, 42, 0.07);
        }
        .ins-body-container {
          padding: 24px;
          background: #f8fafc;
        }
        .pdm-header {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 18px;
          padding: 22px 24px 18px;
          background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
          border-bottom: 1px solid rgba(226, 232, 240, 0.9);
          border-radius: 20px 20px 0 0;
          width: 100%;
        }
          .pdm-header-left {
            display: flex;
            align-items: flex-start;
            gap: 14px;
            min-width: 260px;
            flex: 1 1 360px;
          }
          .pdm-icon-box {
            width: 44px;
            height: 44px;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #ffffff;
            font-size: 18px;
            flex-shrink: 0;
            box-shadow: 0 12px 22px rgba(15, 23, 42, 0.16);
          }
          .pdm-title-block {
            min-width: 0;
          }
          .pdm-title {
            font-size: 16px;
            font-weight: 800;
            color: #0f172a;
            margin: 0;
            line-height: 1.2;
          }
          .pdm-subtitle {
            font-size: 13px;
            color: #64748b;
            margin: 6px 0 0;
            max-width: 620px;
          }
          .pdm-header-actions {
            display: flex;
            align-items: center;
            gap: 8px;
            flex-wrap: wrap;
            justify-content: flex-end;
          }
          .pdm-header-meta {
            display: flex;
            align-items: center;
            gap: 7px;
            flex-wrap: wrap;
            margin-top: 10px;
          }
          .pdm-meta-pill {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            padding: 4px 10px;
            border-radius: 99px;
            background: #ffffff;
            border: 1px solid #cbd5e1;
            color: #475569;
            font-size: 12px;
            font-weight: 700;
          }
          .pdm-btn {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            background: #ffffff;
            border: 1px solid #cbd5e1;
            padding: 8px 16px;
            border-radius: 8px;
            font-family: inherit;
            font-size: 13px;
            font-weight: 600;
            color: #475569;
            cursor: pointer;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
            box-sizing: border-box;
            min-height: 38px;
            text-decoration: none;
            white-space: nowrap;
            outline: none;
          }
          .pdm-btn:hover {
            background: #f8fafc;
            color: #0f172a;
            border-color: #94a3b8;
            transform: translateY(-1px);
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
          }

          .ins-grid {
            display: flex;
            flex-direction: column;
            gap: 1.5rem;
          }
          .ins-card-wrapper {
            background: hsl(0, 0%, 100%);
            border: 1px solid hsl(210, 20%, 90%);
            border-radius: 0.75rem;
            box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.04);
            overflow: hidden;
            transition: transform 0.25s ease, box-shadow 0.25s ease;
            display: grid;
            grid-template-columns: 320px 1fr;
          }
          @media (max-width: 992px) {
            .ins-card-wrapper {
              grid-template-columns: 1fr;
            }
          }
          .ins-card-wrapper:hover {
            transform: translateY(-2px);
            box-shadow: 0 12px 35px -8px rgba(0, 0, 0, 0.08);
          }
          
          .ins-left-card {
            background: linear-gradient(135deg, hsl(265, 80%, 99%) 0%, hsl(265, 50%, 95%) 100%);
            padding: 1.5rem;
            color: hsl(265, 35%, 20%);
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            min-height: 240px;
            border-right: 1px solid hsl(265, 30%, 88%);
          }
          .ins-left-card-bg-glow {
            display: none;
          }
          .ins-left-card-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            z-index: 1;
          }
          .ins-left-card-icon {
            font-size: 1.5rem;
            color: hsl(265, 60%, 45%);
          }
          .ins-left-card-secure-badge {
            font-size: 0.75rem;
            font-weight: 700;
            color: hsl(265, 60%, 40%);
            background: hsl(265, 60%, 95%);
            border: 1px solid hsl(265, 50%, 88%);
            padding: 2px 8px;
            border-radius: 99px;
            letter-spacing: 0.5px;
            text-transform: uppercase;
          }
          .ins-company-name {
            font-size: 1.15rem;
            font-weight: 800;
            letter-spacing: 0.3px;
            color: hsl(265, 35%, 20%);
            margin-top: 1.5rem;
            margin-bottom: 0.5rem;
            line-height: 1.3;
            z-index: 1;
          }
          .ins-left-card-footer {
            margin-top: auto;
            font-size: 0.75rem;
            color: hsl(265, 20%, 50%);
            z-index: 1;
            display: flex;
            align-items: center;
            gap: 0.4rem;
          }
          
          .ins-right-panel {
            padding: 1.5rem;
            display: flex;
            flex-direction: column;
            gap: 1.5rem;
          }
          .ins-policies-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
            gap: 1rem;
          }
          .ins-policy-pill {
            background-color: hsl(210, 20%, 98%);
            border: 1px solid hsl(210, 20%, 93%);
            border-radius: 0.5rem;
            padding: 0.75rem 1rem;
            display: flex;
            flex-direction: column;
            gap: 0.3rem;
            transition: border-color 0.2s, background-color 0.2s;
          }
          .ins-policy-pill:hover {
            border-color: hsl(217, 85%, 85%);
            background-color: hsl(217, 85%, 99%);
          }
          .ins-policy-label {
            font-size: 0.75rem;
            font-weight: 700;
            color: hsl(210, 14%, 40%);
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          .ins-policy-meta {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 0.5rem;
          }
          .ins-policy-number {
            font-family: "Courier New", Courier, monospace;
            font-size: 0.85rem;
            font-weight: bold;
            color: hsl(210, 24%, 16%);
          }
          .ins-policy-number-empty {
            font-size: 0.75rem;
            color: hsl(210, 10%, 65%);
            font-style: italic;
          }
          .ins-policy-expiration {
            font-size: 0.75rem;
            font-weight: 600;
            padding: 2px 6px;
            border-radius: 4px;
            background-color: hsl(210, 20%, 92%);
            color: hsl(210, 14%, 35%);
          }
          .ins-policy-expiration.is-expired {
            background-color: hsl(0, 75%, 95%);
            color: hsl(0, 75%, 35%);
          }
          
          .ins-meta-row {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
            gap: 1.25rem;
            border-top: 1px dashed hsl(210, 20%, 90%);
            padding-top: 1.25rem;
          }
          
          .ins-meta-item {
            display: flex;
            flex-direction: column;
            gap: 0.25rem;
          }
          .ins-meta-label {
            font-size: 0.75rem;
            color: hsl(210, 14%, 45%);
            font-weight: 500;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }
          .ins-meta-value {
            font-size: 0.85rem;
            font-weight: 500;
            color: hsl(210, 24%, 16%);
          }
          .ins-updated-time {
            display: flex;
            align-items: center;
            gap: 0.4rem;
          }
          .ins-updated-time i {
            color: hsl(210, 14%, 60%);
          }
          
          .ins-status-badge {
            display: inline-flex;
            align-items: center;
            gap: 0.4rem;
            padding: 0.25rem 0.65rem;
            border-radius: 0.25rem;
            font-size: 0.75rem;
            font-weight: 600;
            border: 1px solid transparent;
          }
          .ins-status-locked {
            background-color: hsl(0, 75%, 97%);
            border-color: hsl(0, 70%, 93%);
            color: hsl(0, 75%, 35%);
          }
          .ins-status-allowed {
            background-color: hsl(142, 70%, 95%);
            border-color: hsl(142, 60%, 88%);
            color: hsl(142, 70%, 25%);
          }
          .ins-status-requested {
            background-color: hsl(35, 90%, 95%);
            border-color: hsl(35, 90%, 88%);
            color: hsl(35, 90%, 25%);
          }
          
          .ins-action-bar {
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-top: 1px solid hsl(210, 20%, 93%);
            padding-top: 0.85rem;
            margin-top: 0.5rem;
          }
          .ins-btn-primary {
            background-color: hsl(217, 85%, 55%);
            border: 1px solid hsl(217, 85%, 50%);
            color: white;
            padding: 0.4rem 1rem;
            border-radius: 0.375rem;
            font-size: 0.8rem;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s ease;
            display: inline-flex;
            align-items: center;
            gap: 0.3rem;
          }
          .ins-btn-primary:hover {
            background-color: hsl(217, 85%, 48%);
            border-color: hsl(217, 85%, 45%);
            box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
          }
          .ins-btn-secondary {
            background-color: white;
            border: 1px solid hsl(210, 14%, 80%);
            color: hsl(210, 14%, 35%);
            padding: 0.4rem 0.85rem;
            border-radius: 0.375rem;
            font-size: 0.8rem;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s;
          }
          .ins-btn-secondary:hover {
            background-color: hsl(210, 20%, 97%);
            border-color: hsl(210, 14%, 70%);
            color: hsl(210, 14%, 15%);
          }
          
          .ins-remarks-panel {
            font-size: 0.75rem;
            background-color: hsl(210, 20%, 98%);
            border: 1px solid hsl(210, 20%, 93%);
            border-radius: 0.25rem;
            padding: 0.5rem 0.75rem;
            margin-top: 0.5rem;
          }
          .ins-remarks-title {
            color: hsl(210, 14%, 40%);
            font-weight: 600;
            margin-bottom: 0.15rem;
          }
          .ins-remarks-date {
            font-weight: normal;
            color: hsl(210, 24%, 16%);
          }
          .ins-remarks-text {
            color: hsl(210, 10%, 45%);
            font-style: italic;
          }
          
          /* COI File Card Styles */
          .ins-coi-card {
            border: 1px solid hsl(210, 20%, 90%);
            border-radius: 0.5rem;
            padding: 0.75rem 1rem;
            background-color: hsl(210, 20%, 98%);
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 1rem;
            transition: border-color 0.2s ease;
            width: 100%;
          }
          .ins-coi-card:hover {
            border-color: hsl(210, 14%, 80%);
          }
          .ins-coi-empty {
            border: 1px dashed hsl(210, 14%, 80%);
            background-color: transparent;
            cursor: pointer;
            justify-content: center;
            flex-direction: column;
            text-align: center;
            padding: 1rem;
            gap: 0.4rem;
          }
          .ins-coi-empty:hover {
            border-color: hsl(217, 85%, 60%);
            background-color: hsl(217, 85%, 99%);
          }
          .ins-coi-icon {
            font-size: 1.25rem;
            color: hsl(210, 14%, 50%);
          }
          .ins-coi-empty:hover .ins-coi-icon {
            color: hsl(217, 85%, 55%);
          }
          .ins-coi-info {
            display: flex;
            align-items: center;
            gap: 0.6rem;
            overflow: hidden;
          }
          .ins-coi-details {
            display: flex;
            flex-direction: column;
            overflow: hidden;
          }
          .ins-coi-name {
            font-size: 0.8rem;
            font-weight: 600;
            color: hsl(217, 85%, 45%);
            background: transparent;
            border: none;
            text-align: left;
            padding: 0;
            cursor: pointer;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          .ins-coi-name:hover {
            text-decoration: underline;
          }
          .ins-coi-remarks {
            font-size: 0.7rem;
            color: hsl(210, 14%, 50%);
          }
          .ins-coi-actions {
            display: flex;
            align-items: center;
            gap: 0.5rem;
          }
          
          .ins-btn-danger-outline {
            background-color: transparent;
            border: 1px solid hsl(0, 75%, 90%);
            color: hsl(0, 75%, 50%);
            width: 28px;
            height: 28px;
            border-radius: 0.25rem;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.2s;
          }
          .ins-btn-danger-outline:hover {
            background-color: hsl(0, 75%, 97%);
            border-color: hsl(0, 75%, 80%);
            color: hsl(0, 75%, 40%);
          }
          
          .ins-empty-state {
            border: 2px dashed hsl(210, 14%, 85%);
            border-radius: 0.75rem;
            padding: 3rem 2rem;
            text-align: center;
            background-color: hsl(210, 20%, 99%);
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 1rem;
            max-width: 500px;
            margin: 2rem auto;
          }
          .ins-empty-icon {
            font-size: 2.5rem;
            color: hsl(210, 14%, 70%);
            background-color: hsl(210, 20%, 95%);
            width: 70px;
            height: 70px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .ins-empty-title {
            font-size: 1rem;
            font-weight: 600;
            color: hsl(210, 24%, 20%);
            margin: 0;
          }
          .ins-empty-desc {
            font-size: 0.85rem;
            color: hsl(210, 14%, 50%);
            margin: 0;
            line-height: 1.4;
          }
        `}</style>
      {hideHeader !== true && (
        <div className="pdm-header">
          <div className="pdm-header-left">
            <div className="pdm-icon-box" style={{ background: "linear-gradient(135deg, #7c3aed 0%, #2563eb 100%)" }}>
              <i className="fa fa-shield" />
            </div>
            <div className="pdm-title-block">
              <p className="pdm-title">Insurance Information</p>
              <p className="pdm-subtitle">
                Manage, view, and verify business insurance coverages and certificate of insurance (COI) documents.
              </p>
              <div className="pdm-header-meta">
                <span className="pdm-meta-pill">
                  <i className="fa fa-id-badge" /> ID: {item?.fuid || "New"}
                </span>
                {item?.label && (
                  <span className="pdm-meta-pill">
                    <i className="fa fa-user" /> {item.label}
                  </span>
                )}
                {item?.email && (
                  <span className="pdm-meta-pill">
                    <i className="fa fa-envelope-o" /> {item.email}
                  </span>
                )}
                <span className="pdm-meta-pill">
                  <i className="fa fa-info-circle" /> Status: {
                    item
                      ? (item.contact1?.isActive === true
                        ? "Active"
                        : item.contact1?.isActive === false
                          ? "Inactive"
                          : "Pending Activation")
                      : "New Partner"
                  }
                </span>
                {((viewType === "candidateList" ? partnerCurrentWfTask : workflowTask)?.ciid) && (
                  <span className="pdm-meta-pill">
                    <i className="fa fa-hashtag" /> CIID {(viewType === "candidateList" ? partnerCurrentWfTask : workflowTask).ciid}
                  </span>
                )}
                {tmrMessages?.length > 0 && (
                  <span className="pdm-meta-pill" style={{ color: "hsl(0, 75%, 35%)", background: "hsl(0, 75%, 97%)", border: "1px solid hsl(0, 70%, 93%)" }}>
                    <i className="fa fa-exclamation-circle" /> Expiration Alert ({tmrMessages.length})
                  </span>
                )}
                <span className="pdm-meta-pill" style={{ color: "hsl(142, 70%, 25%)", background: "hsl(142, 70%, 95%)", border: "1px solid hsl(142, 60%, 85%)" }}>
                  <i className="fa fa-lock" /> Secured
                </span>
              </div>
            </div>
          </div>
          <div className="pdm-header-actions">
            {typeof onBack === "function" && (
              <button className="pdm-btn" onClick={onBack}>
                <i className="fa fa-arrow-left" style={{ marginRight: "4px" }}></i> Back to list
              </button>
            )}
            <button className="pdm-btn" onClick={handleTimerModalShowHide}>
              <i className="fa fa-bell-o" style={{ marginRight: "4px" }}></i> Expiration Alert <span className="badge badge-pill badge-danger ml-1" style={{ fontSize: "11px", padding: "3px 6px" }}>{tmrMessages?.length || 0}</span>
            </button>
            <button className="pdm-btn" onClick={handleDocumentLoad}>
              <i className="fa fa-refresh"></i> Refresh
            </button>
          </div>
        </div>
      )}
      <div className="ins-body-container">
        <div className="ins-grid">
          {formsLib.map((item, key) => {
            const companyName = workflowTask?.ciid && viewType !== "candidateList" ?
              getFieldData(app?.applicationData, "insurancedetails", "Name_of_the_Insurance_Company") :
              getFieldData(partnerAppData, "insurancedetails", "Name_of_the_Insurance_Company");

            const getPolicyNum = (field) => getPolicyDate("insurancedetails", field) || "Not Provided";
            const getExpiryDate = (field) => getModifiedFiledData("insurancedetails", field);

            const policies = [
              { label: "Commercial General Liability", numField: "Commercial_General_Liability_Policy_Number", expField: "Commercial_General_Liability_Expiration" },
              { label: "Automobile Liability", numField: "Automobile_Liability_Policy_Number", expField: "Automobile_Liability_Expiration" },
              { label: "Umbrella Liability", numField: "Umbrella_Liab_Policy_Number", expField: "Umbrella_Liab_Expiration" },
              { label: "Workers Compensation", numField: "Workers_Compensation_Policy_Number", expField: "Workers_Compensation_Expiration" },
              { label: "Cyber & Privacy Security", numField: "Cyber_Privacy_Security_Liab_Policy_Number", expField: "Cyber_Privacy_Security_Liab_Expiration" },
              { label: "E&O Liability", numField: "E_and_O_Liab_Policy_Number", expField: "E_and_O_Liab_Expiration" }
            ];

            const insuranceDocs = appDocuments.filter(x => x.uploadType === `insurance_${item.id}` && x.deleteFlag !== true);
            const editDate = formatEditDate(
              item.allowEdit === 2 ? item.editReqDateTime : item.allowEditDateTime,
            );

            return (
              <div className="ins-card-wrapper" key={item.id || key}>
                <div className="ins-left-card">
                  <div className="ins-left-card-bg-glow"></div>
                  <div className="ins-left-card-header">
                    <i className="fa fa-shield ins-left-card-icon"></i>
                    <span className="ins-left-card-secure-badge">COI SECURED</span>
                  </div>
                  <div className="ins-company-name">
                    {companyName || "Unknown Insurer"}
                  </div>
                  <div className="ins-left-card-footer">
                    <i className="fa fa-calendar-check-o"></i> Active Policies
                  </div>
                </div>

                <div className="ins-right-panel">
                  <div className="ins-policies-grid">
                    {policies.map((p, idx) => {
                      const pNum = getPolicyNum(p.numField);
                      const pExp = getExpiryDate(p.expField);
                      const isExpired = pExp && moment(pExp, "MMM Do YYYY").isBefore(moment());
                      return (
                        <div className="ins-policy-pill" key={idx}>
                          <div className="ins-policy-label" title={p.label}>{p.label}</div>
                          <div className="ins-policy-meta">
                            {pNum === "Not Provided" ? (
                              <span className="ins-policy-number-empty">Not Provided</span>
                            ) : (
                              <span className="ins-policy-number">{pNum}</span>
                            )}
                            {pExp && (
                              <span className={`ins-policy-expiration ${isExpired ? "is-expired" : ""}`}>
                                {isExpired && <i className="fa fa-exclamation-triangle mr-1"></i>}
                                {pExp}
                              </span>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  <div className="ins-meta-row">
                    <div className="ins-meta-item">
                      <div className="ins-meta-label">Last Updated</div>
                      <div className="ins-meta-value">
                        {item.lastUpdate ? (
                          <div className="ins-updated-time">
                            <i className="fa fa-calendar-o mr-1"></i>
                            <Moment format="MMM Do YYYY">{item.lastUpdate}</Moment>
                            <span style={{ margin: "0 4px", color: "hsl(210, 14%, 70%)" }}>•</span>
                            <Moment format="h:mm a">{item.lastUpdate}</Moment>
                          </div>
                        ) : (
                          <span style={{ color: "hsl(210, 10%, 60%)" }}>Never</span>
                        )}
                      </div>
                    </div>

                    <div className="ins-meta-item">
                      <div className="ins-meta-label">Edit Permissions</div>
                      <div className="ins-meta-value">
                        {item.allowEdit === 0 && (
                          <span className="ins-status-badge ins-status-locked">
                            <i className="fa fa-lock mr-1"></i> Edit Locked
                          </span>
                        )}
                        {item.allowEdit === 2 && (
                          <span className="ins-status-badge ins-status-requested">
                            <i className="fa fa-clock-o mr-1"></i> Request Received
                          </span>
                        )}
                        {item.allowEdit === 1 && (
                          <span className="ins-status-badge ins-status-allowed">
                            <i className="fa fa-check mr-1"></i> Edit Allowed
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  {(item.allowEdit === 2 || item.allowEdit === 1) && (
                    <div className="ins-remarks-panel">
                      <div className="ins-remarks-title">
                        {item.allowEdit === 2 ? "Requested" : "Approved"} on:{" "}
                        <span className="ins-remarks-date">
                          {editDate}
                        </span>
                      </div>
                      {item.editRemarks && (
                        <div className="ins-remarks-text">
                          "{item.editRemarks}"
                        </div>
                      )}
                    </div>
                  )}

                  <div className="ins-meta-item">
                    <div className="ins-meta-label" style={{ marginBottom: "0.4rem" }}>Certificate of Insurance (COI)</div>
                    <div className="ins-meta-value">
                      {insuranceDocs.length === 0 ? (
                        <div
                          className="ins-coi-card ins-coi-empty"
                          onClick={() => handleUploadDocModalShowHide(`insurance_${item.id}`)}
                        >
                          <i className="fa fa-cloud-upload ins-coi-icon"></i>
                          <span style={{ fontSize: "0.8rem", fontWeight: "600", color: "hsl(210, 14%, 30%)" }}>Upload COI</span>
                          <span style={{ fontSize: "0.7rem", color: "hsl(210, 14%, 55%)" }}>PDF or Image format</span>
                        </div>
                      ) : (
                        <div className="ins-coi-card">
                          <div className="ins-coi-info">
                            <i className="fa fa-file-text-o text-primary" style={{ fontSize: "1.25rem" }}></i>
                            <div className="ins-coi-details">
                              <button
                                type="button"
                                className="ins-coi-name"
                                title="Download COI"
                                onClick={() => handleDownloadFile(insuranceDocs[0])}
                              >
                                {insuranceDocs[0].docName}
                              </button>
                              {insuranceDocs[0].remarks ? (
                                <span className="ins-coi-remarks">
                                  {insuranceDocs[0].remarks}
                                </span>
                              ) : (
                                <span className="ins-coi-remarks" style={{ fontStyle: "italic" }}>
                                  No notes provided
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="ins-coi-actions">
                            {insuranceDocs[0].remarks && getPopover(insuranceDocs[0].remarks)}
                            <button
                              type="button"
                              className="ins-btn-danger-outline"
                              title="Delete Document"
                              onClick={() => handleDeleteInsuranceDoc(insuranceDocs[0].docId)}
                            >
                              <i className="fa fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="ins-action-bar">
                    <button
                      className="ins-btn-primary"
                      onClick={() => handleFormShowHide(item)}
                    >
                      <i className="fa fa-wpforms mr-1"></i>
                      View/Edit Form
                    </button>

                    {(item.allowEdit === 0 || item.allowEdit === 2) && (
                      <button
                        className="ins-btn-secondary"
                        onClick={() => handleNoteShowHide("", item)}
                      >
                        <i className="fa fa-key mr-1"></i>
                        Allow Edit
                      </button>
                    )}
                  </div>
                </div>
              </div>
            );
          })}

          {formsLib.length === 0 && achCheckCount === 2 && (
            <div className="ins-empty-state">
              <div className="ins-empty-icon">
                <i className="fa fa-shield"></i>
              </div>
              <h4 className="ins-empty-title">Secure Insurance Verification Required</h4>
              <p className="ins-empty-desc">
                No Insurance Information form has been registered for this account yet. Verification of business liability coverages ensures safe onboarding.
              </p>
              <button
                className="ins-btn-primary"
                style={{ marginTop: "0.5rem" }}
                onClick={() => addReqFormLibrary()}
              >
                <i className="fa fa-plus-circle" style={{ marginRight: "4px" }}></i>
                Initiate Insurance Setup
              </button>
            </div>
          )}
        </div>
      </div>

      {
        achFormShowHide && <ViewFormModal
          viewFormShowHide={achFormShowHide}
          handleViewForm={handleFormShowHide}
          workflowTask={viewType === "candidateList" ? partnerCurrentWfTask : workflowTask}
          selectedForm={selectedForm}
          refereshFormData={refereshFormData}
          formName="Insurance Information"
        ></ViewFormModal>
      }

      {
        noteShowHide && <AddEditNotes
          noteShowHide={noteShowHide}
          handleNoteShowHide={handleNoteShowHide}
          notesType="formEditReq"
          candidateObj={candidateObj}
          selectedObj={selectedForm}
        ></AddEditNotes>
      }


      {
        docShowHide && <CandidateReqDoc
          docShowHide={docShowHide}
          handleDocShowHide={handleUploadDocModalShowHide}
          workItem={viewType === "candidateList" ? partnerCurrentWfTask : workflowTask}
          sendType={"upload"}
          uploadType={uploadType}
          viewType={"candidateList"}
          applicantObj={candidateObj}
        ></CandidateReqDoc>
      }

      {
        timerShowHide &&
        <TimerPopup
          timerShowHide={timerShowHide}
          handleTimerModalShowHide={handleTimerModalShowHide}
          tmrMessages={tmrMessages}
        ></TimerPopup>
      }
    </div >
  );
}

export default InsuranseInformation;
